export default "__VITE_ASSET__53753d60__"